import FormExtra from '../components/FormExtra';
import { ReactNode } from 'react';

interface Field {
  labelText: string;
  labelFor: string;
  id: string;
  name: string;
  type: string;
  autoComplete: string;
  isRequired: boolean;
  placeholder: string;
  extra?: ReactNode;
  tabIndex?: number;
  note?: string;
}

export const loginFields: Field[] = [
  {
    labelText: 'Email',
    labelFor: 'emailAddress',
    id: 'emailAddress',
    name: 'email',
    type: 'email',
    autoComplete: 'email',
    isRequired: true,
    placeholder: 'Email address',
    tabIndex: 1,
  },
  {
    labelText: 'Password',
    labelFor: 'password',
    id: 'password',
    name: 'password',
    type: 'password',
    autoComplete: 'current-password',
    isRequired: true,
    placeholder: 'Password',
    tabIndex: 2,
    extra: <FormExtra />,
  },
];

export const signupFields: Field[] = [
  {
    labelText: 'First Name',
    labelFor: 'firstName',
    id: 'firstName',
    name: 'firstName',
    type: 'text',
    autoComplete: 'firstName',
    isRequired: true,
    placeholder: 'First Name',
    tabIndex: 1,
  },
  {
    labelText: 'Last Name',
    labelFor: 'lastName',
    id: 'lastName',
    name: 'lastName',
    type: 'text',
    autoComplete: 'lastName',
    isRequired: false,
    placeholder: 'Last Name',
    tabIndex: 2,
  },
  {
    labelText: 'Email address',
    labelFor: 'emailAddress',
    id: 'emailAddress',
    name: 'email',
    type: 'email',
    autoComplete: 'email',
    isRequired: true,
    placeholder: 'Email address',
    tabIndex: 3,
  },
  {
    labelText: 'Password',
    labelFor: 'password',
    id: 'password',
    name: 'password',
    type: 'password',
    autoComplete: 'currentPassword',
    isRequired: true,
    placeholder: 'Password',
    note: 'Minimum 8 characters.',
    tabIndex: 4,
  },
  {
    labelText: 'Confirm Password',
    labelFor: 'confirmPassword',
    id: 'confirmPassword',
    name: 'confirmPassword',
    type: 'password',
    autoComplete: 'currentPassword',
    isRequired: true,
    placeholder: 'Confirm Password',
    note: 'Minimum 8 characters.',
    tabIndex: 5,
  },
];
export const signupPasswordFields: Field[] = [
  {
    labelText: 'Password',
    labelFor: 'password',
    id: 'password',
    name: 'password',
    type: 'password',
    autoComplete: 'currentPassword',
    isRequired: true,
    placeholder: 'Password',
    tabIndex: 1,
  },
  {
    labelText: 'Confirm Password',
    labelFor: 'confirmPassword',
    id: 'confirmPassword',
    name: 'confirmPassword',
    type: 'password',
    autoComplete: 'confirmPassword',
    isRequired: true,
    placeholder: 'Confirm Password',
    tabIndex: 2,
  },
];
export const passwordResetRequestFields: Field[] = [
  {
    labelText: 'Email address',
    labelFor: 'emailAddress',
    id: 'emailAddress',
    name: 'email',
    type: 'email',
    autoComplete: 'email',
    isRequired: true,
    placeholder: 'Email address',
    tabIndex: 1,
  },
];

export const passwordResetFields: Field[] = [
  {
    labelText: 'Password',
    labelFor: 'password',
    id: 'password',
    name: 'password',
    type: 'password',
    autoComplete: 'currentPassword',
    isRequired: true,
    placeholder: 'Password',
    tabIndex: 1,
  },
  {
    labelText: 'Confirm Password',
    labelFor: 'confirmPassword',
    id: 'confirmPassword',
    name: 'confirmPassword',
    type: 'password',
    autoComplete: 'confirmPassword',
    isRequired: true,
    placeholder: 'Confirm Password',
    tabIndex: 2,
  },
  {
    labelText: 'Reset Hash',
    labelFor: 'resetHash',
    id: 'resetHash',
    name: 'resetHash',
    type: 'hidden',
    autoComplete: 'resetHash',
    isRequired: true,
    placeholder: 'Reset Hash',
    tabIndex: 3,
  },
];
